import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  teamId: string;
  enabled?: boolean;
}

// Reads the team's current active join token (null if none/expired/revoked).
const useJoinToken = ({ teamId, enabled = true }: IProps) => {
  const query = useQuery({
    queryKey: ['teams', 'join-token', teamId],
    queryFn: async () => {
      const response = await Api.getJoinToken(teamId);
      return response.data.data;
    },
    enabled: enabled && Boolean(teamId),
  });

  return {
    joinToken: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};

export default useJoinToken;
